<template>
    <div>
        <Skeleton />
    </div>
</template>

<script>
	import Skeleton from './Skeleton.vue';
    export default {
        components: {
            Skeleton
        }
    };
</script>

<style lang="scss" scoped></style>
